import { useRef, useState } from 'react';
import DashboardWrapper from '../dashboard/DashboardWrapper';
import CotizacionesDashboardView from '../../shared/Cotizaciones/CotizacionesDashboardView';
import { useAdminToast } from '../shell/AdminToastContext';

export const DashboardPage = () => {
    const toast = useAdminToast();

    const [dataBuro, setDataBuro] = useState([]);
    const [selectedPerson, setSelectedPerson] = useState(null);
    const [people, setPeople] = useState([]);
    const [loading, setLoading] = useState(false);
    const [categories, setCategories] = useState(null);
    const [canContinue, setCanContinue] = useState(false);
    const [categoriasFaltantes, setCategoriasFaltantes] = useState([]);
    const onSelectPersonRef = useRef(null);

    if (selectedPerson) {
        return (
            <DashboardWrapper
                dataBuro={dataBuro}
                setDataBuro={setDataBuro}
                setLoading={setLoading}
                loading={loading}
                toast={toast}
                setSelectedPerson={setSelectedPerson}
                selectedPerson={selectedPerson}
                people={people}
                setPeople={setPeople}
                categories={categories}
                setCategories={setCategories}
                setCanContinue={setCanContinue}
                canContinue={canContinue}
                setCategoriasFaltantes={setCategoriasFaltantes}
                categoriasFaltantes={categoriasFaltantes}
                onSelectPersonRef={onSelectPersonRef}
            />
        );
    }

    return (
        <CotizacionesDashboardView
            toast={toast}
            onSelectPerson={(person) => setSelectedPerson(person)}
        />
    );
};

export default DashboardPage;
